import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

// import columnConfig from './columnConfig'

import Button from 'share-ui/components/Button/Button'
import Table from 'components/Table'

import useApiKeys from './useApiKeys'

import { ButtonPrimary } from 'components/Button/Button'
import {
    StyledHeaderGroup,
    StyledSectionDescription,
    StyledSectionTitle,
} from 'pages/Home/homeStyle.css'

import {
    StyledChatWrapper,
    StyledContainer,
    StyledHorizontalDivider,
    StyledMainWrapper,
} from 'routes/ChatRouteLayout'
import { StyledAppContainer } from 'components/Layout/LayoutStyle'
import { StyledTableWrapper } from 'pages/Billing/panels/Transactions'
import { useModal } from 'hooks'

const ApiKeys = () => {
    const { t } = useTranslation()
    const { apiKeys, api_keys_loading, config } = useApiKeys()

    const { openModal } = useModal()

    return (
        <StyledAppContainer>
            <StyledContainer>
                <StyledMainWrapper>
                    <StyledChatWrapper>
                        <StyledHeaderGroup className='header_group'>
                            <div>
                                <StyledSectionTitle>API Keys</StyledSectionTitle>
                                <StyledSectionDescription>
                                    <StyledTypography>
                                        {t('api-keys-authenticate')}
                                        <StyledTypographyWrapper></StyledTypographyWrapper>
                                    </StyledTypography>
                                </StyledSectionDescription>
                            </div>

                            <ButtonPrimary
                                onClick={() => openModal({ name: 'add-api-keys-modal' })}
                                size={Button.sizes?.MEDIUM}
                            >
                                {t('create-api-key')}
                            </ButtonPrimary>
                        </StyledHeaderGroup>

                        <StyledHorizontalDivider />

                        <StyledTableWrapper>
                            <Table
                                columns={config}
                                data={apiKeys || []}
                                isLoading={api_keys_loading}
                            />
                        </StyledTableWrapper>
                    </StyledChatWrapper>
                </StyledMainWrapper>
            </StyledContainer>
        </StyledAppContainer>
    )
}

export default ApiKeys

const StyledTypography = styled.div`
    display: flex;
    position: relative;
    justify-content: flex-start;
    align-items: center;

    @media (max-width: 1209px) {
        margin-left: auto;
        margin-top: auto;
        display: flex;
        position: relative;
        top: 60px;
    }
`
const StyledTypographyWrapper = styled.div`
    text-decoration: underline;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 75px;
    min-width: 30px;
    height: 20px;
    margin-left: 10px;
    margin-bottom: 5px;

    @media (max-width: 320px) {
        margin-left: auto;
        margin-top: auto;
        display: flex;
        position: relative;
        right: 65px;
        top: 40px;
        width: fit-content;
    }
`
